// eslint-disable-next-line import/no-extraneous-dependencies
import type BoundingRect from 'zrender/lib/core/BoundingRect';
import type ExtensionAPI from 'echarts/types/src/core/ExtensionAPI';
import { getLayoutRect } from 'echarts/lib/util/layout';
import type { Group } from 'zrender';
import type { TreeNode } from 'echarts/types/src/data/Tree';
import type { TwoWayTreeSeriesModelClazz as TwoWayTreeSeriesModel } from './TwoWayTreeSeries';
import type { TwoWayTreeViewClazz as TwoWayTreeView } from './TwoWayTreeView';

export function clearSelected(seriesModel: TwoWayTreeSeriesModel, api: ExtensionAPI) {
  seriesModel.leftTree.eachNode('preorder', (node: TreeNode) => {
    node.__selected = false;
  });
  seriesModel.rightTree.eachNode('preorder', (node_: TreeNode) => {
    node_.__selected = false;
  });

  const seriesView = api.getViewOfSeriesModel(seriesModel) as TwoWayTreeView;

  seriesView?.group?.traverse(childEl => {
    childEl.clearStates();
  });
}

export function adapt(
  seriesModel: TwoWayTreeSeriesModel,
  api: ExtensionAPI,
  option: {
    target?: Group;
    animation?: boolean | { time?: number; during?: (percent: number) => void; done?: () => void };
    noScale?: boolean;
    viewCenter?: [number, number];
  } = {}
) {
  const boxLayoutParams = seriesModel.getBoxLayoutParams();
  const view = api.getViewOfSeriesModel(seriesModel) as TwoWayTreeView;

  api.getZr().flush();
  api.getZr().resize();
  // api.resize();

  const viewportBoxRect = getLayoutRect(boxLayoutParams, {
    width: api.getWidth(),
    height: api.getHeight()
  }) as BoundingRect;
  const viewCenter = option?.viewCenter || [0.5, 0.5];
  // * 视区中心
  const viewportCenter = [
    viewportBoxRect.x + viewportBoxRect.width * viewCenter[0],
    viewportBoxRect.y + viewportBoxRect.height * viewCenter[1]
  ];

  const target = typeof option.target === 'undefined' ? view.group : option.target;
  const bBox = target.getBoundingRect();
  if (target.parent === view.group) {
    bBox.x += target.x;
    bBox.y += target.y;
  }
  // * 图形中心
  const targetCenter = [bBox.x + bBox.width / 2, bBox.y + bBox.height / 2];

  // 根据宽高比使得内容充满容器
  const scale =
    bBox.width / bBox.height < viewportBoxRect.width / viewportBoxRect.height
      ? viewportBoxRect.height / bBox.height
      : viewportBoxRect.width / bBox.width;

  const zoomScale = option.noScale ? view.group.scaleX / 1 : scale / 1;
  // 缩放后的图形中心位置
  targetCenter[0] = (targetCenter[0] - 0) * zoomScale;
  targetCenter[1] = (targetCenter[1] - 0) * zoomScale;

  view._transformTo(
    {
      // // 设置缩放中心为图形中心
      // originX: targetCenter[0],
      // originY: targetCenter[1],
      // 缩放
      scaleX: option.noScale ? undefined : scale,
      scaleY: option.noScale ? undefined : scale,
      // 将图形中心与视区中心对齐，进行偏移调整
      x: viewportCenter[0] - targetCenter[0],
      y: viewportCenter[1] - targetCenter[1]
    },
    option.animation
  );

  //
}
